//* Libraries imports
import z from "zod";

/**
 * Validating a name with a minimum of 3 characters and a maximum of 255 characters.
 *
 * @example
 * const name = "Roberto" // Valid
 * const name = "Ro" // Invalid
 * const name = "Roberto
 */

export const nameSchema = z
  .string({
    invalid_type_error: "O nome deve ser um texto",
    required_error: "O nome é obrigatório",
  })
  .min(3, {
    message: "O nome deve ter no mínimo 3 caracteres",
  })
  .max(255, {
    message: "O nome deve ter no máximo 255 caracteres",
  });
